import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { AuditLogFilters, AuditLogList } from "@/api/types";

const KEY = ["audit-log"] as const;

export function useAuditLog(filters: AuditLogFilters = {}) {
  return useQuery({
    queryKey: [...KEY, filters],
    queryFn: () => {
      const params: Record<string, string | number> = {};
      if (filters.actor) params.actor = filters.actor;
      if (filters.action) params.action = filters.action;
      if (filters.resource_type)
        params.resource_type = filters.resource_type;
      if (filters.resource_id) params.resource_id = filters.resource_id;
      if (filters.since) params.since = filters.since;
      if (filters.until) params.until = filters.until;
      params.limit = filters.limit ?? 50;
      params.offset = filters.offset ?? 0;
      return api.GET<AuditLogList>("/audit-log", { params });
    },
  });
}
